import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

export interface Insight {
  sentiment_description: string
  mentions_count: number
}

export interface SentimentData {
  promoters: Insight[]
  detractors: Insight[]
  passives: Insight[]
}

export interface IAIInsightsData extends SentimentData {
  ai_insights: SentimentData
}

class AIInsightsData extends Model<IAIInsightsData> {
  constructor(attr = {} as IAIInsightsData) {
    super(attr)
    makeObservable(this, {
      promoters: computed,
      detractors: computed,
      passives: computed,
    })
  }

  get indexes() {
    return ['enps_form_id', 'cycle_start_on', 'cycle_end_on']
  }

  static urlRoot() {
    return '/enps/ai_insights/summary'
  }

  get promoters(): Insight[] {
    return this.attributes.promoters
  }
  get detractors(): Insight[] {
    return this.attributes.detractors
  }
  get passives(): Insight[] {
    return this.attributes.passives
  }
}

export default AIInsightsData
